export function seed(a: any, b: Record<string, string>) {
  return Promise.resolve(null);
}
